import React from 'react';
import styled from 'styled-components';

import type HTMLProps from '@zimpel/common/HTMLProps';
import Tooltip from '@zimpel/common/components/Tooltip';

const StyledTruncate = styled.span<{ $maxWidth: string }>`
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  max-width: ${({ $maxWidth }) => $maxWidth};
`;

type Props = { width: string, tooltip?: string } & HTMLProps & React.PropsWithChildren;

const Truncate: React.FC<Props> = ({
  children, width, tooltip, ...rest
}) => (
  children
    ? (
      <Tooltip content={tooltip || (typeof children === 'string' ? children : undefined)}>
        <StyledTruncate $maxWidth={width} {...rest}>
          {children}
        </StyledTruncate>
      </Tooltip>
    )
    : null
);

export default Truncate;
